<template>
  <b-field label="Rayon (mètres)*" :message="error" :type="error !== null ? 'is-danger' : ''">
    <b-input :value="radius" type="number" :min="minRadius" @input="input" />
  </b-field>
</template>

<script>
const MIN_RADIUS = 50
const MAX_RADIUS = 500000

export default {
  name: 'RadiusField',

  props: {
    radius: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      error: null,
    }
  },

  created() {
    this.minRadius = MIN_RADIUS
  },

  watch: {
    radius(radius) {
      this.error = this.getError(radius)
    },
  },

  methods: {
    getError(radius) {
      return radius < MIN_RADIUS || radius > MAX_RADIUS
        ? `Le rayon doit être compris entre ${MIN_RADIUS}m et ${MAX_RADIUS}m`
        : null
    },

    input(radius) {
      radius = Number(radius)

      this.error = this.getError(radius)

      this.$emit('error', this.error !== null)

      if (this.error === null) {
        this.$emit('update:radius', radius)
      }
    },
  },
}
</script>
